import { toast } from "react-toastify";
import { API_AUTH, ORIGIN, REFERER, SCOPE } from "../constants/api";
import { IAccess, IToken, IUser, IValidate } from "../interfaces/IToken";

export function clearAuthStorage() {
    localStorage.removeItem("access");
    localStorage.removeItem("csrf_token");
    localStorage.removeItem("userInfo");
}


export class HttpError extends Error {
    constructor(public status: number, message?: string) {
        super(message ?? `HTTP ${status}`);
        this.name = "HttpError";
    }
}
export function redirectToLogin() {
    //Не забыть поменять на https://auth.ddwhub.kz/
    window.location.href = `https://auth.ddwhub.kz/login?redirect_uri=${encodeURIComponent(
        window.location.origin
    )}`;
}

export function redirectToLocalLogin() {
    clearAuthStorage()
    const redirectBack = window.location.href;
    window.location.href = `${window.location.origin}/login?redirect_uri=${encodeURIComponent(
        redirectBack
    )}`;
}


export async function validateAccess(
    access: string,
    action: string,
    csrf_token: string
): Promise<boolean> {
    const res = await fetch(`${API_AUTH}/v1/validate`, {
        method: "POST",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
            "Referer": REFERER as string,
            "Origin": ORIGIN as string,
        },
        body: JSON.stringify({ access, action, scope: SCOPE, csrf_token }),
    });
    //T0009 вцепить ошибку и сразу отправить на логин
    if (!res.ok) throw new HttpError(res.status, "Validate failed");

    const data: IValidate = await res.json();
    return data.result === true;
}


export async function refreshToken(): Promise<string | false> {
    const csrf_token = localStorage.getItem("csrf_token");
    const res = await fetch(`${API_AUTH}/v1/refresh`, {
        method: "POST",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
            Referer: `${REFERER}`,
            Origin: `${ORIGIN}`,
        },
        body: JSON.stringify({
            scope: SCOPE,
            action: "refresh_pair",
            csrf_token,
        }),
    });

    if (!res.ok) return false;
    const data: IValidate | IAccess = await res.json();

    if ("result" in data && data.result === false) {
        localStorage.removeItem("access");
        localStorage.removeItem("csrf_token");
        return false;
    }

    if ("access" in data && data.access) {
        localStorage.setItem("access", data.access);
        return data.access;
    }

    return false;
}

export async function Logout(access: string, csrf_token: string) {
    const res = await fetch(`${API_AUTH}/v1/logout`, {
        method: "POST",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
            Referer: `${REFERER}`,
            Origin: `${ORIGIN}`,
        },
        body: JSON.stringify({ access, csrf_token }),
    });
    if (!res.ok) {
        throw new Error(`Logout error ${res.status}`);
    }
    localStorage.clear();
}

export async function fetchTokenByCode(code: string, redirect_uri: string): Promise<void> {
    const url = `${API_AUTH}/v1/tokens/?grant_type=token_pair&code=${encodeURIComponent(
        code
    )}&redirect_uri=${encodeURIComponent(redirect_uri)}&scope=${SCOPE}`;

    const res = await fetch(url, { method: "GET", credentials: "include" });

    if (!res.ok) {
        throw new HttpError(res.status, "Token exchange failed");
    }

    const data: IToken = await res.json();
    const user: IUser = {
        role: data.role,
        employee_code: data.employee_code
    }
    localStorage.setItem("access", data.access);
    localStorage.setItem("csrf_token", data.csrf_token);
    localStorage.setItem("userInfo", JSON.stringify(user));
}

type ApiEnvelope<T> = { result: boolean; details?: string } & Partial<T>;

export async function callApiWithAuth<T>(
    url: string,
    action: string,
    body?: Record<string, unknown>,
    accept201 = false
): Promise<T> {
    const buildBody = () => {
        const access = localStorage.getItem("access");
        const csrf = localStorage.getItem("csrf_token");
        const userInfo = JSON.parse(localStorage.getItem("userInfo") as string) as IUser;

        const credentials = {
            access,
            scope: SCOPE,
            action,
            csrf_token: csrf,
            employee_code: userInfo?.employee_code,
        };

        return JSON.stringify({ ...body, credentials });
    };

    async function request(): Promise<ApiEnvelope<T>> {
        const res = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Referer: REFERER as string,
                Origin: ORIGIN as string,
            },
            body: buildBody(),
        });


        if (accept201 && res.status === 201) {
            return { result: true } as ApiEnvelope<T>;
        }

        if (res.status === 403) {
            toast.warning("Нет прав доступа")
            throw new HttpError(403, "Forbidden");
          }


        let json: ApiEnvelope<T> | null = null;
        try {
            json = (await res.json()) as ApiEnvelope<T>;
        } catch {

        }

        if (!res.ok) {
            if (json && typeof json.result === "boolean") {
                return json;
            }
            throw new HttpError(res.status, `HTTP ${res.status}`);
        }

        return (json ?? { result: true }) as ApiEnvelope<T>;
    }

    const first = await request();
    if (first.result) return first as any;

    const code = first.details;

    if (code === "T0007") {
        toast.warning("Нет прав доступа")
        throw new Error("NO_PERMISSION");
      }

    if (code === "T0003" || code === "T0008" || code === "T0001") {
        const refreshed = await refreshToken();
        if (typeof refreshed !== "string") {
            redirectToLocalLogin();
            throw new Error("Need login");
        }

        const second = await request();
        if (second.result) return second as any;

        redirectToLocalLogin();
        throw new Error(second.details || "NO_PERMISSION");
    }

    redirectToLocalLogin();
    throw new Error(code || "NO_PERMISSION");
}

